import React, { useContext, useState } from "react";
import { View, StyleSheet } from "react-native";
import routesmap from "../root/data/routesmap";
import UserContext from "../context/UserContext";

export const usePermission = (type, path) => {
  const [allow, setAllow] = useState(false);
  const context = useContext(UserContext);

  //first, will fetch the route map object
  const route = routesmap?.find((each) => each.path == path);

  // second, will check if user has permisson to that module
  if (route) {
    const permissions = context.user?.permissions?.filter((each) =>
      each.permission_name?.startsWith(
        `${route?.module}.${route?.action}.${type}`
      )
    );

    if (allow != permissions?.length > 0) {
      setAllow(permissions?.length > 0);
    }
  }

  return allow;
};
